import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { LoanSummaryStore } from '../stores';

export const useLoanSummaryStore = () => useContext<{
  loanSummaryStore: LoanSummaryStore
}>(StoreContext);
